import { GET_STARTED_ENTRY_ROUTE } from '~/get-started/entryRoute.const'
import useSkipsOnboarding from '~/get-started/hooks/useSkipsOnboarding'
import ROUTES from '~/shared/constants/routes.const'

/** Where a "Get started" CTA goes: the onboarding, or registration for visitors who skip it. */
export default function useGetStartedEntryRoute(entryRoute: string = GET_STARTED_ENTRY_ROUTE): string {
  return useSkipsOnboarding() ? ROUTES.REGISTER : entryRoute
}
